module.exports = __webpack_public_path__ + "static/media/9.850eb1b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatars/9.jpg
// module id = 223
// module chunks = 14